module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#cricket",
      toString: function () {
        return this.url;
      }
    }